import { render, staticRenderFns } from "./StockTranfer.vue?vue&type=template&id=5021b8da&"
import script from "./StockTranfer.vue?vue&type=script&lang=js&"
export * from "./StockTranfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports